// import HomeWebService from "../service/home_web_service";
import moment from "moment";
import DataResult from "../data/bean/data_result";
import GeneralWebService from "../service/general_web_service";
import Labels from "../ui/constant/labels";
import AuthBloc from "./auth_bloc";
import GeneralBloc from "./general_bloc";
import CryptoJS from "crypto-js"
import forge from "node-forge";

export default class UtilBloc {
  static detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

static calculateInterateRate(value){
  let convert=0;
  if(value<=3){
    convert=3;
  }
  if(value >3 && value<=4){
    convert=4;
  }

  if(value >4 && value<=5){
    convert=5;
  }

  if(value >5 && value<=6){
    convert=6;
  }

  if(value >6 && value<=7){
    convert=7;
  }

  if(value >7 && value<=8){
    convert=8;
  }

  if(value >8 && value<=9){
    convert=9;
  }

  if(value >9 && value<=12){
    convert=12;
  }

  if(value >12 && value<=15){
    convert=15;
  }

  if(value >15 && value<=18){
    convert=18;
  }

  return convert;

}

//isMobile checking user is using mobile or desktop browser
static isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

  //Check is value is not null && not undefined
  static b64toBlob(b64Data, contentType,filename ,action) {
    contentType = contentType || '';
    var sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    var byteCharacters = window.atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    let a = document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([blob], { type: contentType }))    
    if(action=="download"){
     a.download = filename;
    } 

    if(action=="print"){
      a.target="_blank" 
    }

    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
  }

  //integer_to_roman
  static integer_to_roman(num) {
    if (typeof num !== "number") return false;

    var digits = String(+num).split(""),
      key = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
      ],
      roman_num = "",
      i = 3;
    while (i--) roman_num = (key[+digits.pop() + i * 10] || "") + roman_num;
    return Array(+digits.join("") + 1).join("M") + roman_num;
  }
  
  //Show EN or BM version
  static convertToLocaleObject(en, bm) {
    return {
      en: en,
      bm: bm,
    };
  }

  //groupCategory for Uploaded Documents
  static groupCategory(data) {
    let result = [];
    result = data.reduce(function (r, a) {
      r[a.document.code] = r[a.document.code] || [];
      r[a.document.code].push(a);
      return r;
    }, Object.create(null));
    return result;
  }

  //Check value is valid value or not
 /*  static isValid(value) {
    if (value !== undefined) return true;
    if (value !== null) return true;
    return false;
  } */

  //Check if value is null or empty
  static isNullOrEmpty(value) {
    return (
      value === undefined ||
      !value ||
      value === null ||
      value === "" ||
      value === "undefined"
    );
  }

  // Check if value is a future date
  static isFutureDate(currentDate) {
    let customDate = moment(new Date()).format("DD-MM-YYYY");
    return currentDate && currentDate > moment(customDate, "DD-MM-YYYY");
  }

  static isCurrentDateBetween19And100YearsAgo(currentDate) {
    // Check if the current date is between 19 and 100 years ago
    if (currentDate > moment(new Date()).subtract(17, "years")) {
      return true;
    } else if (currentDate < moment(new Date()).subtract(65, "years")) {
      return true;
    } else return false;
  }
  
  //Convert MegaBytes
  static convertToMB(size) {
    return (size / (1024 * 1024)).toFixed(2);
  }

  //Covert string to capitalize
  static capitalize(string) {
    return string[0].toUpperCase() + string.substr(1).toLowerCase();
  }

  //Format number
  static formatNumber(num) {
    let value = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    if (value === "NaN") {
      return 0;
    }
    return value;
  }
  //this.formatNumber(parseFloat(num).toFixed(2));

  static getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  //Format number with commas
  static numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  static blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]); // Get Base64 without the metadata
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Converts the Blob to a Base64 data URL
    });
  }

  static binaryToBase64(binaryData) {
    // Convert the binary data to a string of characters
    const binaryString = Array.from(new Uint8Array(binaryData))
      .map(byte => String.fromCharCode(byte))
      .join('');
    
    // Encode the string to Base64
    return btoa(binaryString);
  }

  //Create a tag with download click
  static downloadBinary(response, filename) {
    let a = document.createElement("a");
    a.href = window.URL.createObjectURL(new Blob([response]));
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  static truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
  }

  //addFirstItemInArray
  static addFirstItemInArray(arr, object) {
    return [object].concat(arr);
  }

  //no use
  static async exportFileByModule(
    entity,
    dateFilter,
    fromDate,
    toDate,
    regions,
    page,
    searchBy,
    keyword,
    branches,
    agents,
    idModuleListing
  ) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }

    let getDateFilter = GeneralBloc.getFilteredByDate(
      dateFilter,
      fromDate,
      toDate
    );

    let response = await GeneralWebService.exportFileByModule(
      token,
      entity,
      page,
      getDateFilter.beginDate,
      getDateFilter.endDate,
      regions,
      searchBy,
      keyword,
      branches,
      agents,
      idModuleListing,
      dateFilter
    );

    return response;
  }

  //validatePassword
  static validatePassword(value, name) {
    let expregular =
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#$%^&*])(?=.{8,})";
    let error = null;
    if (!value) {
      error = `Please enter ${name} password.`;
    } else if (!value.match(expregular)) {
      error =
        "Password must contain between 8-16 characters, with upper case, lower case, special character and numeric characters.";
    }
    return error;
  }

  //validateUserName
  static validateUserName(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter user name`;
    }
    return error;
  }

  static validateField(value, name) {
    let error = null;
    if (!value) {
      if (name == "username") {
        error = Labels.ERROR_USERNAME;
      } else {
        error = Labels.ERROR_PASSWORD;
      }
    }
    return error;
  }

  //formatDateFollowingFormat
  static formatDateFollowingFormat(date,type){
    return moment(date).format(type)
  }

  static decryptionImage(data) {
    let SALT_LENGTH = 16;
    let ENCRYPTED_KEY_LENGTH = 128;
    let KEY_LENGTH = 16;
    let IV_LENGTH = 16;
    let AUTH_TAG_LENGTH = 24;
    let decodebase64str = atob(data);    
    let RandomKey = decodebase64str.slice(SALT_LENGTH + ENCRYPTED_KEY_LENGTH).substring(0, KEY_LENGTH)
    let decodeTag = forge.util.decode64(decodebase64str.slice(SALT_LENGTH + ENCRYPTED_KEY_LENGTH + KEY_LENGTH + IV_LENGTH).substring(0, AUTH_TAG_LENGTH))
    let decodedData = forge.util.decode64(decodebase64str.slice(SALT_LENGTH + ENCRYPTED_KEY_LENGTH + KEY_LENGTH + IV_LENGTH + AUTH_TAG_LENGTH))
    let decodeIv = decodebase64str.slice(SALT_LENGTH + ENCRYPTED_KEY_LENGTH + KEY_LENGTH).substring(0, IV_LENGTH)
    let decipher = forge.cipher.createDecipher(process.env.REACT_APP_ENCRYTION_METHOD, RandomKey);
    decipher.start({
      iv: forge.util.createBuffer(decodeIv),
      additionalData: process.env.REACT_APP_ADDITIONAL_DATA, // optional
      tagLength: 128, // optional, defaults to 128 bits
      tag: decodeTag // authentication tag from encryption
    });
    decipher.update(forge.util.createBuffer(decodedData));
    decipher.finish();
    return decipher.output.data
  }

}
